"use strict";
// istanbul ignore file
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ProgressCircular_1 = tslib_1.__importDefault(require("./ProgressCircular"));
const ProgressLogo_1 = tslib_1.__importDefault(require("./ProgressLogo"));
const Progress = { Logo: ProgressLogo_1.default, Circular: ProgressCircular_1.default };
// eslint-disable-next-line import/no-default-export
exports.default = Progress;
//# sourceMappingURL=index.js.map